import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";
import { PrimaryButton } from "components/Button/style";

export const Button = styled(PrimaryButton)`
  margin-top: 1.67rem;
  width: 8rem;
`;

export const ButtonEnviar = styled(PrimaryButton)`
  width: 100px;
  margin-top: 1.67rem;
  margin-right: 5rem;
`;

export const ButtonRenovar = styled(PrimaryButton)`
  width: auto;
  min-width: 12rem;
  white-space: nowrap;
`;
